import clsx from 'clsx';
import React from 'react';

const sizeClasses = {
    xs: 'text-xs',
    sm: 'text-sm',
    base: 'text-base',
    lg: 'text-lg',
};

interface TextProps {
    as?: 'p' | 'span' | 'div';
    size?: keyof typeof sizeClasses;
    muted?: boolean;
    className?: string;
    children: React.ReactNode;
}

const Text: React.FC<TextProps> = ({
    as: Tag = 'p',
    size = 'base',
    muted = false,
    className,
    children,
}) => {
    return (
        <Tag
            className={clsx(
                'font-body',
                sizeClasses[size],
                muted && 'text-gray-500',
                className
            )}
        >
            {children}
        </Tag>
    );
};

export default Text;
